import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    background: "#001d2f",
    minWidth: '100%',
    minHeight: '100%',
  },
  registerButton: {
    background: 'rgb(5, 56, 85)',
    color: theme.palette.common.white,
    display: 'flex',
    marginTop: 10,
  },
  loginButton: {
    background: 'rgb(2, 152, 235)',
    color: theme.palette.common.white,
    display: 'flex',
    margin: theme.spacing(3, 0, 2),
  },
  root: {
    minWidth: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  card: {
    display: 'flex',
    alignItems: 'center',
  },
  cardContent: {
    padding: 0,
    minWidth: '600px',
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  registerCard: {
    background: 'rgb(2, 152, 235)',
    padding: 25,
  },
  innerGrid: {
    padding: 25,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  containerForm: {
    color: theme.palette.grey['600'],
  },
  logo: {
    height: '150px',
    marginBottom: '50px',
  },
  logoGlobal: {
    height: '114px',
    marginBottom: '0px',
  },
  link: {
    cursor: 'pointer',
    align: 'right',
    color: 'inherit',
  },
  imgBox: {
    display: "flex", 
    justifyContent: "center"
  }
}))
